<mat-card>
  <mat-card-title>
      <mat-icon>error</mat-icon>
      <span tabindex="0">{{ "paginaError404.titulo" | translate }}</span>
  </mat-card-title>
  <mat-card-content>
    <p tabindex="0">{{ "paginaError404.contenido" | translate }}</p>
  </mat-card-content>
</mat-card>